import { xhrStatusUIState } from 'redux/reusable/xhrStatus';
import type { IState } from 'redux/state';
import { createSelector } from 'reselect';
import { keyBy } from 'utils/typesafe';

const readXhrStatus = (state: IState) => state.roles.xhrStatus;
const readUserRoles = (state: IState) => state.roles.userRoles;

export const getXhrStatus = createSelector([readXhrStatus], xhrStatus =>
  xhrStatusUIState(xhrStatus)
);
export const getUserRoles = readUserRoles;

export const getDefaultUserRoleId = createSelector(
  [getUserRoles],
  roles => (roles.find(role => role.default) ?? roles[0] ?? { id: -1 }).id
);

export const getUserRoleById = createSelector([getUserRoles], userRoles => keyBy(userRoles, 'id'));
